import { useState } from 'react';

import { DEFAULT_LANGUAGE } from '@app/utils/languages';

export const useFormLanguage = () => {
  const [language, setLanguage] = useState(DEFAULT_LANGUAGE);

  const handleChangeLanguage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLanguage((event.target as HTMLInputElement).value as string);
  };

  return { language, handleChangeLanguage };
};
